exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.help-popover[data-v-8dcb0740] {\n    color: #007bff;\n}\n", ""]);

